<template>
  <div>
    <!-- <router-link
      :to="{
        name: 'industrial_group_branch_tank_report',
        query: {
          branchId: data.branchID,
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : localStorage.getItem('companyID'),
        },
      }"
    >
      <button class="outline">View Tank Details</button>
    </router-link> -->

    <router-link
      :to="{
        name: 'IndustrialBranchDashboard',
        query: {
          branchId: data.branchID,
          groupId: this.$route.query.groupID
            ? this.$route.query.groupID
            : data.groupId,
          companyId: this.$route.query.companyId
            ? this.$route.query.companyId
            : localStorage.getItem('companyID'),
        },
      }"
    >
      <button>{{ $t("text.clickButtons.toDashboard") }}</button>
    </router-link>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
};
</script>

<style scoped>
button {
  background-color: #370f70;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
}

.outline {
  background-color: transparent;
  border: 1px solid #370f70;
  color: #370f70;
}
</style>
